// React libraries
import React from 'react';
// Component Style
import { IconButtonDialogTitleCloseButton, StyledDialogContent, StyledDialogTitle, StyledTypography, StyledDialog, useStyles } from "./DialogBoxStyles";
// Icons
import { Typography } from '@mui/material';
import { Color, FONT_FAMILY } from '../../constants';
import { Close } from '../../sap_icons';
export const DialogBox = (props) => {
    const classes = useStyles(props);
    const { id, open, noClose = false, noPadding, handleClose, textTitle = "Dialog Box Title", titleType = "header", content = React.createElement(DefaultContent, null), style, typographyStyle, maxWidth = false, fullWidth = false } = props;
    const dialogTitleTextProps = {
        fontFamily: titleType === 'header' ? FONT_FAMILY.CAPITOLIUM_BOLD : FONT_FAMILY.ROBOTO_REGULAR,
        size: titleType === 'header' ? 24 : 12,
        color: titleType === 'header' ? Color.neutral[900] : Color.neutral[500]
    };
    return (React.createElement(StyledDialog, { nopadding: noPadding, open: open || false, onClose: handleClose, 
        // PaperProps={{
        //     sx: {
        //         overflowX: 'hidden',
        //         opacity: 1,
        //         borderRadius: 0,
        //         boxShadow: "0px 2px 34px 0px rgba(0, 0, 0, 0.23)",
        //         padding: noPadding ? 0 : '24px',
        //         zIndex: 2500
        //     }
        // }}
        // classes={{ paper: classes.dialogPaper, root: classes.backdrop }}
        // BackdropProps={{
        //     sx: {
        //         position: "fixed",
        //         backgroundColor: `${Color.primary[900]} !important`,
        //         opacity: '0.8 !important',
        //     }
        // }}
        style: style, id: id, maxWidth: maxWidth ? maxWidth : false, fullWidth: fullWidth },
        React.createElement(StyledDialogTitle, { nopadding: noPadding },
            React.createElement(StyledTypography, { style: typographyStyle, fontFamily: dialogTitleTextProps.fontFamily, size: dialogTitleTextProps.size, color: dialogTitleTextProps.color }, textTitle),
            !noClose && (React.createElement(IconButtonDialogTitleCloseButton, { className: classes.dialogTitleCloseButton, onClick: handleClose, disableRipple: true, size: "large" },
                React.createElement(Close, null)))),
        React.createElement(StyledDialogContent, null, content)));
};
export const DefaultContent = () => (React.createElement(React.Fragment, null,
    React.createElement(Typography, null, "Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros."),
    React.createElement(Typography, null, "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor."),
    React.createElement(Typography, null, "Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.")));
export default React.memo(DialogBox);
